'use es6';

import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload = 0
  } = action;

  switch (type) {
    case Actions.DEALS_CURRENCY_SYMBOL_FETCH_SUCCEEDED:
      {
        if (payload) {
          const {
            homeCurrency,
            currencyExchangeRates
          } = payload;
          state = state.set('dealsCurrencyCode', homeCurrency.currencyCode).set('currencyExchangeRates', currencyExchangeRates);
        }

        break;
      }

    default:
      break;
  }

  return state;
});